<template>
	<footer v-click-outside-app="defocusApp">
        <div class="page-grid-fix">
            <article class="grid-container columns-two image-left transparent large-gap">
                <section class="section1">
                    <div>
                      
                        <div>
                            <h4>Speak to our experts</h4>
                            <p >Here at Ninety we aim to build long-lasting relationships with all of our clients. We will always encourage you to talk to us should you have any questions or need any advice. <br />Please enter your details and we will call you or contact us on 
                              <span style="color: #ae9248;"><a class="phone_number" style="color: #ae9248;" :href="'tel:' + londonboutique.PhoneNumber">{{ londonboutique.PhoneNumber }}</a>
                            </span>
                          </p>
                        </div>
                    </div>
                </section>
                <section class="section2">
                    <ContactForm></ContactForm>  
                </section>
            </article>
        </div>

        <div class="footer-contact-container" id="subscribe">            
            <div class="text">
                <div>
                    <h2>Register for updates<br>on our latest stock</h2>
                </div>
            </div>
            <div class="subscribe">
                <div>
                   
                    <Subscribe></Subscribe>
                </div>
            </div>
            <div class="contact">
                <div>
                    <div class="email icon"><a :href="'mailto:' + londonboutique.Email"><img class="center" src="/images/icons/email-grey.svg"></a> </div>
                    <div class="phone icon"><a class="phone_number" :href="'tel:' + londonboutique.PhoneNumber"><img class="center" src="/images/icons/Phone.svg"></a> </div>
                    <div class="whatsapp icon"><a class="contact-whatsapp whatsapp" v-if="londonboutique.WhatsAppNumber" :href="'https://wa.me/'+ londonboutique.WhatsAppNumber"><img class="center" src="/images/icons/whatsapp-grey.svg"></a> </div>
                    <!-- <div class="wechat icon"><a class="contact-wechat wechat" :href="'weixin://dl/chat?wechatid=NinetyWatches'"><img class="center" src="/images/icons/wechat-grey.svg"></a></div> -->
                    
                    <!-- WeChat Icon -->
                    <!-- <div class="wechat icon">
                        <a class="contact-wechat wechat" @click="handleWechatClick">
                            <img class="center" src="/images/icons/wechat-grey.svg" alt="WeChat">
                        </a>
                    </div> -->

                    <!-- QR Code Popup -->
                    <!-- <div v-if="showQr" class="wechat-qr-overlay wechat icon" @click="closeQr">
                        <a class="contact-wechat wechat">
                            <div class="wechat-qr-popup" @click.stop>
                            
                                <img src="/images/wechat-qr-ninetywatches.jpeg" alt="Scan with WeChat" />
                                <p>Scan with WeChat to contact us</p>
                            </div>
                        </a>
                    </div>     -->
                </div>
            </div>
            <div class="social">
                <div>
                    <div class="tweeter icon"><a href="https://twitter.com/NinetyWatches"><img class="center" src="/images/icons/x-logo.svg"></a> </div>
                    <div class="insta icon"><a :href="londonboutique.InstagramURL"><img class="center" src="/images/icons/Instagram.svg"></a> </div>
                    <div class="facebook icon"><a :href="londonboutique.FacebookURL"><img class="center" src="/images/icons/Facebook.svg"></a> </div>
                    <div class="linkedin icon"><a href="https://www.linkedin.com/company/ninetymountstreet"><img class="center" src="/images/icons/Linkedin.svg"></a> </div>
                    <div class="snapchat icon"><a :href="'http://snapchat.com/add/ninety_watches'"><img class="center" src="/images/icons/snapchat-grey.svg"></a></div>
                    <div class="youtube icon"><a :href="'https://www.youtube.com/@NinetyWatchesJewellery'"><img class="center" src="/images/icons/youtube-grey.svg"></a></div>
                    <div class="up icon">
                        <div id="scroll-top-arrow" v-scroll-to="'#toScroll'" style="position: relative;"><img class="center" src="/images/icons/ArrowTop.svg"></div>
                    </div>
                </div>
            </div>
            <div class="gleft"></div>
            <div class="gright"></div>
            <div class="links">
                <div>
                    <router-link to="/">
                    Home
                    </router-link>
                    <router-link to="/richard-mille-watches">
                    Richard Mille
                    </router-link>
                    <router-link to="/the-collection">
                    All Brands
                    </router-link>
                    <router-link to="/new-arrivals">
                    New Arrivals
                    </router-link>
                    <router-link to="/about">
                    About
                    </router-link>
                    <router-link to="/services">
                    Services
                    </router-link>
                    <router-link to="/legal">
                    Legal
                    </router-link>
                    </div>
            </div>
            <div class="logo"> 
                <div class="ninety">
                    <!-- <div class="address"></div> -->
                    <!-- <router-link to="/" v-scroll-to="'#toScroll'"> <img alt="Ninety - Richard Mille Official Pre-Owned Retailer" src="../assets/Logo-Thick-Gold.svg"> </router-link> -->
                </div>
            </div>
            <div class="gleft-contact"></div>
            <div class="gleft-links"></div>
            <div class="gleft-text"></div>
        </div>
 		
	</footer>
</template>

<script>
import ContactForm from '../components/ContactForm.vue'
import Subscribe from '../components/Subscribe.vue'
import { mapState } from 'vuex'

export default {
  name: 'Appfooter',
  components: {
    ContactForm,
    Subscribe,
  },

  data() {
    return {
      mapShow: true,
      showQr: false, // for QR popup visibility
    }
  },

  directives: {
    'click-outside-app': {
      bind: function (el, binding) {
        const ourClickEventHandler = (event) => {
          if (!el.contains(event.target) && el !== event.target) {
            binding.value(event)
          }
        }
        el.__vueClickEventHandler__ = ourClickEventHandler
        document.addEventListener('click', ourClickEventHandler)
      },
      unbind: function (el) {
        document.removeEventListener('click', el.__vueClickEventHandler__)
      },
    },
  },

  computed: {
    ...mapState('boutiques', ['londonboutique', 'siteSettings']), // pull from Vuex
    currentRouteName() {
      return this.$route.name
    },
  },
  mounted() {
    if (!this.londonboutique || !this.londonboutique.PhoneNumber) {
      this.$store.dispatch('boutiques/fetchLondon') 
    if (!this.siteSettings || !Object.keys(this.siteSettings).length) {
      this.$store.dispatch('boutiques/fetchSiteSettings')
      }
    }
  },
  methods: {
    toggleClass() {
      this.mapShow = !this.mapShow
    },
    defocusApp() {
      this.mapShow = true
    },
    closeQr() {
      this.showQr = false
    },
  },
}
</script>